import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { useUser } from "../config/userProvider";
import { apiurl } from "../config/config";
import { Link, useNavigate } from "react-router-dom";
import { InfiLoader } from "../components/loader";
import ButtonContainer, { DeleteButton } from "../components/buttonContainer";
import { IoAddOutline } from "react-icons/io5";
import SearchContainer from "../components/searchContainer";
import { PopModel } from "../components/popupModels";
import BackHeader from "../components/backHeader";
import Pagination from "../components/pagination";
import Card from "../components/card";
import { toast } from "react-toastify";
import DataNotFound from "../components/dataNotFound";
// import Loader from "../loader.svg";
// import Loader from "../../../public/loader.svg"
// import ReactPaginate from "react-paginate";
// import { FiSearch } from "react-icons/fi";
// import { IoMdAddCircle } from "react-icons/io";
// import { TbFileUpload } from "react-icons/tb";

const Stores = () => {
  const [showImportContainer, setShowImportContainer] = useState(false);
  let { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;
  console.log("userData", userData.userType);
  const navigate = useNavigate();
  // const { permissions } = useUser();
  const [loading, setLoading] = useState(false);
  const [deleteStoresLoading, setDeleteStoresLoading] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  // =================== PAGINATION =================
  // const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  const [deleteStoreIds, setDeleteStoreIds] = useState([]);
  const [isDeleted, WantToDelete] = useState(false);
  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // =======================================================
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const storeDetails = (id) => {
    //  console.log("STORE ID IS:", id)
    navigate(`/stores/${id}`);
  };

  const fetchStores = () => {
    setLoading(true);
    let data = JSON.stringify({
      vendorObjId: vendorObjId,
      page: currentPage,
      // limit: JSON.parse(itemsPerPage),
      limit: 5000,
    });

    const config = {
      method: "post",
      url: `${apiurl}/admin/v1/store/get`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("response.data", response.data);
        setStoreData(response?.data?.stores);
        setLoading(false);
        setPaginationData(response?.data?.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  // useEffect(() => {
  //   fetchStores();
  // }, [currentPage, itemsPerPage]);
  useEffect(() => {
    fetchStores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, vendorObjId]);

  // const filterdata = storeData.filter(
  //   (store) =>
  //     store.storeDetails?.name
  //       .toLowerCase()
  //       .includes(searchInput.toLowerCase()) ||
  //     store.storeCode.toLowerCase().includes(searchInput.toLowerCase())
  // );

  const filterdata = storeData.filter(
    (store) =>
      // search condition
      (store.storeDetails?.name
        ?.toLowerCase()
        .includes(searchInput.toLowerCase()) ||
        store.storeCode?.toLowerCase().includes(searchInput.toLowerCase())) &&
      // admin-store restriction
      (userData?.userType !== "admin" ||
        !userData?.storeDetails?.storeObjId ||
        store._id === userData.storeDetails.storeObjId),
  );

  console.log("filterdata", filterdata);

  const AllCheckedHandler = () => {
    if (filterdata.length !== deleteStoreIds.length) {
      filterdata.forEach((item) =>
        setDeleteStoreIds((prev) => [...prev, item._id]),
      );
    } else {
      setDeleteStoreIds([]);
    }
  };

  const CheckedHandler = (id) => {
    const contain = deleteStoreIds.includes(id);
    if (contain) {
      setDeleteStoreIds(deleteStoreIds.filter((i) => i !== id));
    } else {
      setDeleteStoreIds((prev) => [...prev, id]);
    }
  };

  const DeleteHandler = () => {
    setDeleteStoresLoading(true);
    let data = JSON.stringify({
      storeObjIds: deleteStoreIds,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/store/delete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          toast.success(
            response?.data?.message
              ? response?.data?.message
              : "Store deleted successfully",
          );
          WantToDelete(false);
          fetchStores();
          setDeleteStoresLoading(false);
          setDeleteStoreIds([]);
        } else {
          toast.error(
            response?.data?.message
              ? response?.data?.message
              : "Failed to delete store.",
          );
          setDeleteStoresLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to delete store, Please try again later.");
        setDeleteStoresLoading(false);
      });
  };

  console.log("deleteStoreIds", deleteStoreIds);
  return (
    <Layout>
      {isDeleted && (
        <Card.Confirmation
          message="Are you sure?"
          onConfirm={() => DeleteHandler()}
          onClose={() => WantToDelete(false)}
          loading={deleteStoresLoading}
          loadingTitle="Deleting..."
        />
      )}
      <Container>
        {loading === true ? (
          <InfiLoader maintext="Fetching Stores Data..." />
        ) : (
          // <div className="bg-white/100  relative  overflow-hidden rounded-2xl px-2  h-full">
          //   <div className="flex justify-between items-center m-2 p-2">
          //     <div>
          //       <h1 className="text-3xl font-medium text-center mb-3 text-slate-500">Stores</h1>
          //     </div>
          //     <div className="flex gap-5">
          //       <Link
          //         to='/stores/add'
          //         className="flex justify-center items-center px-4 py-1 border-[1px] border-slate-200 bg-slate-500 text-white rounded-md"
          //       >
          //         Add Store
          //       </Link>

          //       <div className="flex items-center py-1 px-3 rounded-full bg-gray-50 border focus-within:border-gray-300 max-w-xl">
          //         <FiSearch className="text-gray-400 text-xl" />
          //         <input
          //           type="text"
          //           placeholder="search Store..."
          //           className="bg-transparent w-full focus:outline-none pr-4 font-semibold border-0 focus:ring-0 px-2"
          //           value={searchInput}
          //           onChange={(e) => setSearchInput(e.target.value)}
          //         />
          //         <button className="flex items-center justify-center min-w-[130px] px-4 rounded-full bg-slate-500 text-white font-medium border-transparent py-1.5 h-[38px] -mr-3">
          //           Search
          //         </button>
          //       </div>
          //     </div>
          //   </div>

          //   <div className=" pb-2 overflow-scroll relative overflow-x-auto border-2 border-slate-100 sm:rounded-lg  h-[75%] ">
          //     <table class=" w-full text-sm text-left rtl:text-right text-gray-500  ">
          //       <thead className="text-xs text-gray-700 uppercase sticky top-0">
          //         <tr class="border-b border-gray-200  bg-gray-50 ">
          //           <th scope="col" className="px-6 py-3">
          //             Sn.
          //           </th>
          //           <th scope="col" className="px-6 py-3 bg-gray-50 ">
          //             Store Name
          //           </th>
          //           <th scope="col" className="px-6 py-3">
          //             Store Code
          //           </th>
          //           <th scope="col" className="px-6 py-3 bg-gray-50 ">
          //             Store Manager Name
          //           </th>
          //           <th scope="col" className="px-6 py-3">
          //             Store Phone
          //           </th>
          //           <th scope="col" className="px-6 py-3">
          //             Store Address
          //           </th>
          //         </tr>
          //       </thead>
          //       <tbody>
          //         {storeData &&
          //           storeData?.map((item, index) => {
          //             return (
          //               <tr className="border-b last-of-type:border-none border-gray-200 cursor-pointer" onClick={() => storeDetails(item?._id)}>
          //                 <td scope="row" class="px-6 py-3">
          //                   {index + 1}
          //                 </td>
          //                 <td
          //                   scope="row"
          //                   class="px-6 py-3 font-medium text-gray-900 whitespace-nowrap bg-gray-50 "
          //                 >
          //                   {item?.storeDetails.name}
          //                 </td>
          //                 <td scope="row" class="px-6 py-3">
          //                   {item?.storeCode}
          //                 </td>
          //                 <td scope="row" class="px-6 py-3 bg-gray-50 ">
          //                   {item?.managerDetails?.name}
          //                 </td>
          //                 <td scope="row" class="px-6 py-3">
          //                   {item?.storeDetails?.phone}
          //                 </td>
          //                 <td scope="row" class="px-6 py-3">
          //                   {item?.storeDetails?.address}
          //                 </td>
          //               </tr>
          //             );
          //           })}
          //       </tbody>
          //     </table>
          //   </div>
          // </div>

          <div className="border border-slate-200 sm:rounded-lg md:rounded-xl h-full w-full px-2 py-2">
            {/* <div className="flex flex-col md:flex-row justify-between items-center m-2 p-2">
              <div>
                <h1 className="text-3xl font-medium text-center mb-3 text-slate-500">Stores</h1>
              </div>
              <div className="flex flex-col md:flex-row gap-2 md:gap-5 w-full md:w-auto">
                <Link
                  to='/stores/add'
                  className="flex justify-center items-center px-4 py-1 border-[1px] border-slate-200 bg-slate-500 text-white rounded-md"
                >
                  Add Store
                </Link>
                <div className="flex items-center py-1 px-3 rounded-full bg-gray-50 border focus-within:border-gray-300 max-w-xl w-full">
                  <FiSearch className="text-gray-400 text-xl" />
                  <input
                    type="text"
                    placeholder="search Store..."
                    className="bg-transparent w-full focus:outline-none pr-4 font-semibold border-0 focus:ring-0 px-2"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <button className="flex items-center justify-center min-w-[130px] px-4 rounded-full bg-slate-500 text-white font-medium border-transparent py-1.5 h-[38px] -mr-3">
                    Search
                  </button>
                </div>
              </div>
            </div> */}
            <div className="bg-white relative flex flex-col gap-2 w-full overflow-hidden rounded-lg sm:rounded-xl px-2 h-full ">
              <div className="flex flex-col md:flex-row justify-between items-center h-[10%]">
                <BackHeader
                  title={
                    <span className="flex flex-col md:flex-row items-center">
                      Stores
                      <span className="hidden lg:flex">
                        {" "}
                        {/* - {paginationData?.totalItems} */}
                        {userData?.userType !== "admin" && (
                          <>- {paginationData?.totalItems}</>
                        )}
                      </span>
                      {/* <select
                        value={itemsPerPage}
                        className="text-xs rounded text-black border px-2 md:mx-2"
                        onChange={(e) => setItemsPerPage(e.target.value)}
                      >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select> */}
                    </span>
                  }
                  rightSide={
                    <div className="flex gap-2 md:hidden">
                      {deleteStoreIds.length > 0 &&
                        userData?.userType === "superadmin" && (
                          <DeleteButton onClick={() => WantToDelete(true)} />

                          // <button
                          //   onClick={() => WantToDelete(true)}
                          //   className="bg-red-50 hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg text-xs py-1 px-2 "
                          // >
                          //   Delete
                          // </button>
                        )}
                      <button
                        className="border text-xs  py-1 px-2 rounded-md border-zinc-900 hover:bg-zinc-900  hover:text-white"
                        onClick={() => setShowImportContainer(true)}
                      >
                        Import
                      </button>
                      <Link to="/stores/add" className="">
                        <ButtonContainer
                          icon={<IoAddOutline />}
                        ></ButtonContainer>
                      </Link>
                    </div>
                  }
                />
                <div className="flex md:gap-2 justify-center md:justify-end items-center md:items-end w-full ">
                  <div className="hidden md:flex items-center gap-2">
                    {deleteStoreIds.length > 0 &&
                      userData?.userType === "superadmin" && (
                        <button
                          onClick={() => WantToDelete(true)}
                          className="bg-red-50 hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg py-2 px-3 text-sm lg:text-base"
                        >
                          Delete
                        </button>
                      )}
                    <button
                      className="border py-2 px-3 rounded-md border-zinc-900 hover:bg-zinc-900  hover:text-white text-sm lg:text-base"
                      onClick={() => setShowImportContainer(true)}
                    >
                      Import
                    </button>
                    <Link to="/stores/add">
                      <ButtonContainer icon={<IoAddOutline />}>
                        Create
                      </ButtonContainer>
                    </Link>
                    <SearchContainer
                      value={searchInput}
                      placeholder={"Search Store..."}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="overflow-scroll relative overflow-x-auto border-slate-100 sm:rounded-lg h-[100%] md:h-[85%]">
                {filterdata && filterdata.length > 0 ? (
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase sticky top-0 bg-gray-50">
                      <tr className="border-b border-gray-200">
                        <th scope="col" class="p-4">
                          <div class="flex items-center">
                            <input
                              id="checkbox-all-search"
                              type="checkbox"
                              checked={
                                filterdata.length === deleteStoreIds.length
                              }
                              onClick={AllCheckedHandler}
                              class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 "
                            />
                            <label for="checkbox-all-search" class="sr-only">
                              checkbox
                            </label>
                          </div>
                        </th>
                        <th scope="col" className="px-4 py-3 sm:px-6">
                          Sn.
                        </th>
                        <th scope="col" className="px-4 py-3 sm:px-6">
                          Store Name
                        </th>
                        <th scope="col" className="px-4 py-3 sm:px-6">
                          Store Code
                        </th>
                        <th scope="col" className="px-4 py-3 sm:px-6">
                          Store Manager Name
                        </th>
                        <th scope="col" className="px-4 py-3 sm:px-6">
                          Store Phone
                        </th>
                        <th scope="col" className="px-4 py-3 sm:px-6">
                          City,Province Code
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterdata &&
                        filterdata.length > 0 &&
                        filterdata.map((item, index) => (
                          <tr
                            key={item?._id}
                            className="border-b last-of-type:border-none border-gray-200 cursor-pointer"
                          >
                            <td class="w-4 p-4">
                              <div class="flex items-center">
                                <input
                                  id="checkbox-table-search-1"
                                  type="checkbox"
                                  checked={deleteStoreIds.includes(item._id)}
                                  onClick={() => CheckedHandler(item._id)}
                                  class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500   focus:ring-2 "
                                />
                                <label
                                  for="checkbox-table-search-1"
                                  class="sr-only"
                                >
                                  checkbox
                                </label>
                              </div>
                            </td>
                            <td className="px-4 py-3 sm:px-6">{index + 1}</td>
                            <td className="px-4 py-3 sm:px-6 font-medium text-gray-900 whitespace-nowrap bg-gray-50">
                              {item?.storeDetails?.name}
                            </td>
                            <td className="px-4 py-3 sm:px-6">
                              {item?.storeCode}
                            </td>
                            <td className="px-4 py-3 sm:px-6 bg-gray-50">
                              {item?.managerDetails?.managerName
                                ? item?.managerDetails?.managerName
                                : item?.managerDetails?.name}
                            </td>
                            <td className="px-4 py-3 sm:px-6">
                              {item?.storeDetails?.phone}
                            </td>
                            <td className="px-4 py-3 sm:px-6">
                              {item?.storeDetails?.addressDetails?.city},{" "}
                              {
                                item?.storeDetails?.addressDetails
                                  ?.province_code
                              }
                            </td>

                            <td
                              className="pl-4 sm:pl-6 py-4 text-blue-500 "
                              onClick={() => storeDetails(item?._id)}
                            >
                              view
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <DataNotFound.Page label="Store" />
                )}
              </div>
              {userData?.userType !== "admin" && (
                <Pagination
                  currentPage={currentPage}
                  totalItems={paginationData?.totalItems}
                  // itemsPerPage={itemsPerPage}
                  itemsPerPage={10}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          </div>
        )}
      </Container>

      {showImportContainer && (
        <PopModel setShowImportContainer={setShowImportContainer}></PopModel>
      )}
    </Layout>
  );
};

export default Stores;
